import React, { useState } from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import { FooterMobile } from "../../Layout/FooterMobile";
import config from '../../config';
import { Link } from 'react-router-dom';
import MarkTopicAsReadButton from '../../components/MarkTopicAsReadButton';
import { useChecklist } from '../../context/ChecklistContext';
import { useEnrollmentPortalStatus } from '../../context/EnrollmentPortalStatusContext';
import { useOverviewContext } from '../../context/OverviewContext';
import { getChatUrl } from '../../utils/menuUtils';
import imageEnrollportal from '../../assets/images/siteImg/checklistImg/Image_EnrollmentPortal_Desktop.png';

const SchoolDocuments: React.FC = () => {
const { HOME, SCHOOL_PREP_CHECKLIST, FORM_DOCS_VIEW_ALL } = config.app.routes;
const { identityId } = useOverviewContext(); 
const [isModalOpen, setIsModalOpen] = useState(false);
const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
};

// Get checklist data & currentChecklistId from ChecklistContext
const { checklistData } = useChecklist();
const consentChecklist = checklistData.find(item => item.checklistName === "SCHOOL_DOCUMENTS");
const currentChecklistId = consentChecklist ? consentChecklist.checklistId.toString() : null;

const { verifyUserEmail, portalUrl } = useEnrollmentPortalStatus();
const [email, setEmail] = useState("");
const [error, setError] = useState<string | null>(null); 

const handleVerifyEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
        setError("Please provide a valid e-mail address that was used when enrolling.");
        return;
    }
    setError(null);
    const result = await verifyUserEmail(email, setError);
    console.log("API Result:", result);
    if(portalUrl) {
        console.log("Redirecting to:", portalUrl);
        window.location.href = portalUrl;
    }else if(error) {
        // console.log(error);
        setError(error);   
    }  
};
const chatUrl = identityId ? getChatUrl(identityId) : '';
return (
    <div className="home-layout">
        <div className="sidebar-wrapper">
        <Sidebar />
        </div>
        <div className="body-wrapper-content">
            <div className="row">
                <div className="col-12">
                <Header />
                <div className="main-content">
                    <div className="row">
                        <div className="col-12">
                        <nav aria-label="breadcrumb" className="d-none d-sm-block">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href={HOME}>Home</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href={SCHOOL_PREP_CHECKLIST}>School Prep Checklist</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href={FORM_DOCS_VIEW_ALL}>Forms and Documents</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <span>School Documents</span>
                                </li>
                            </ol>
                        </nav>
                        </div>
                    </div>

                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '66.66%' }}>
                        <div className="wp-block-k12-section container-fluid bg-transparent">
                            <div className="row">
                            <div className="col-12 g-0">
                                <h1 className="wp-block-heading">School Documents</h1>
                                <h4 className="wp-block-heading">
                                Here's a recap of some information from the enrollment process.
                                </h4>
                            </div>
                            </div>
                        </div>

                        <div className="wp-block-k12-section container-fluid bg-color-blue-t1-checklist">
                            <div className="row">
                            <div className="col-12 g-0">
                                <div className="wp-block-k12-content-block">
                                <div className="row p-5">
                                    <div className="col-md-12 col-lg-6 d-flex flex-column gap-2 order-1">
                                    <h2>Enrollment Portal Documents</h2>
                                    <h4>
                                        Your student's enrollment is approved, but it's crucial that we receive all required documents to keep their status secure.
                                    </h4>
                                    <p>
                                        Remember to check your portal to see if you need to take any further action now or once your student starts.
                                    </p>
                                    <div className="btn-primary text-center">
                                        <button onClick={toggleModal}>Log in to the Enrollment Portal</button>
                                    </div>
                                    </div>
                                    <div className="col-md-12 col-lg-6 align-self-end order-2">
                                    <img width="968"
                                        height="716"
                                        src={imageEnrollportal}
                                        alt="Enrollment Portal"
                                        className="wp-image-347 img-fluid"
                                    />
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>

                        <div className="wp-block-k12-school-document-loop container-fluid">
                            <div className="row">
                            <div className="col-12">
                                <div className="container p-0">
                                <div className="row gap-2">
                                    {/* Dynamic checklist items can be mapped here */}
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>

                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '33.33%' }}>
                        {/* Sidebar or additional content can go here */}
                        </div>
                    </div>

                    {currentChecklistId && <MarkTopicAsReadButton checklistId={currentChecklistId} />}

                    {/* Modal */}
                    {isModalOpen && (
                        <div className="wp-block-k12-modal enrollment-modal">
                        <div className="k12-modal-overlay" onClick={toggleModal}></div>
                        <div className="k12-modal">
                            <div className="k12-modal-content">
                            <div className="wp-block-k12-enrollment-link-form">
                                <div className="container">
                                <div className="row">
                                    <div className="col">
                                    <h2 className="text-center text-color-blue-1 fw-bold">Sign in to the Enrollment Portal</h2>
                                    <p className="text-color-blue-1 fw-bold">
                                        Enter the email address that was used when enrolling your student(s) in K12.
                                    </p>
    
                                    <div className="form-group">
                                        <form className="enrollment-link row g-3 needs-validation" onSubmit={handleVerifyEmail}>
                                        <input
                                            type="email"
                                            className={`form-control ${error ? "is-invalid" : ""}`}
                                            id="email"
                                            placeholder="Type email"
                                            value={email}
                                            onChange={(e) => {
                                                setEmail(e.target.value);
                                                if (error) setError(null); 
                                            }}                                        
                                        />
                                        <small id="emailHelp" className="form-text text-muted d-flex mt-2">
                                            <a
                                            target="_blank"
                                            href={chatUrl}
                                            rel="noopener noreferrer"
                                            >
                                            Forgot Email
                                            </a>
                                        </small>
                                        <div className="invalid-feedback mt-2" style={{ display: error ? "block" : "none" }}>
                                            {error}
                                        </div>

                                        <div className="btn-primary inverted text-center d-flex w-100 justify-content-center">
                                            <button type="submit" className="w-75">Go</button>
                                            
                                        </div>
                                        <small className="form-text text-muted d-flex justify-content-center">
                                            <a role="button" className="k12_modal_close" onClick={toggleModal}>Close</a> 
                                        </small>
                                        </form>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    )}
                </div>

                </div>
            </div>
        </div>
        <FooterMobile />            
    </div>
);
};
export default SchoolDocuments;